export default __webpack_public_path__ + "static/media/dog-being-checked-by-the-vet-at-the-pet-shop1.e4e9b7ca.png";